module.exports = __webpack_public_path__ + "img/twitter.19700331.svg";